import styled from "styled-components";

const TooltipWrapper = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  font-size: 12px;
  padding: 6px;
  transform: translate(-50%, -50%);
  font-family: "AllianceNo2-Regular" !important;
`;

const TooltipHeader = styled.div`
  font-family: "AllianceNo2-SemiBold" !important;
  font-size: 13px;
  font-weight: 100 !important;
  margin-bottom: 8px;
`;

const TooltipEntryWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;
`;

const TooltipLabel = styled.div`
  width: 100px;
  font-family: "AllianceNo2-Regular" !important;
`;

const TooltipValue =styled.div`
  font-family: "AllianceNo2-SemiBold" !important;
`;

const KEY_LABEL_MAP = {
    duration: "Duration",
    ip: "IP Address",
    megabytes: "Mbytes",
    rate: "Rate",
    top: "Top Contributor",
    topmbytes: "Top Mbytes",
    failsyn: "Fail SYN",
    topfailsyn: "Top Fail SYN",
    maxrate: "Max Rate"
}


const TooltipEntry = ({ label, value }) => {
    return <TooltipEntryWrapper>
        <TooltipLabel>{KEY_LABEL_MAP[label] || label}</TooltipLabel>
        <TooltipValue>{value}</TooltipValue>
    </TooltipEntryWrapper>;
}

export const Tooltip = ({ interactionData, width, height }) => {
  if (!interactionData) {
    return null;
  }

  const { xPos, yPos, details, date, duration } = interactionData;

  return (
    <div
      style={{
        height,
        width: width,
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
      }}
    >
      <TooltipWrapper
        style={{
          position: "absolute",
          width: "auto",
          left: xPos + 80,
          top: yPos,
        }}
      >
        <TooltipHeader>{date}</TooltipHeader>
        <TooltipEntry label={"duration"} value={duration} />
        {Object.entries(details).map(([key, value]) => {
          return <TooltipEntry label={key} value={value} />;
        })}
      </TooltipWrapper>
    </div>
  );
};

export default Tooltip;
